module.exports = __webpack_public_path__ + "static/media/E3.63783f1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/E3.mp4
// module id = W40r
// module chunks = 8